import React from 'react'
import styled, { css } from 'styled-components'
import { WizardStepProps } from '.'

export const wizardNavStyles = css`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	height: ${props => props.theme.sizes.header.mobile.val};
	.step {
		border: 1px solid ${props => props.theme.colors.secondary.val};
		flex: 1;
		max-width: 18px;
		height: 18px;
		border-radius: 50%;
		margin: 0 15px;
		&.active {
			background-color: ${props => props.theme.colors.primary.light(2).val};
		}
	}
`

const WizardNavView = styled.div`
	${wizardNavStyles}
`

type WizardNavProps = {}
export const WizardNav = ({ ...stepProps }: WizardNavProps) => {
	const { totalSteps, currentStep } = stepProps as WizardStepProps
	return (
		<WizardNavView>
			{new Array(totalSteps).fill(undefined).map((_, idx) => (
				<span key={`step-${idx}`} className={`step ${idx + 1 === currentStep ? 'active' : ''}`} />
			))}
		</WizardNavView>
	)
}
